import { QueryClient } from "@tanstack/react-query";
import { redirect } from "react-router-dom";
import { getCabinetQueryOptions } from "@/entities/cabinet/api/getCabinetQueryOptions";
import { CabinetStatuses } from "@/pages/Cabinet/types";

export const repeatLoanLoader = (queryClient: QueryClient) => async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return redirect("/auth", { status: 301 });
  }

  const response = await queryClient.fetchQuery(getCabinetQueryOptions(token));
  if (response?.component !== CabinetStatuses.repeat) {
    return redirect("/cabinet", { status: 301 });
  }

  return response;
};
